import { render, staticRenderFns } from "./DivisionFilter.vue?vue&type=template&id=5f505e50"
import script from "./DivisionFilter.vue?vue&type=script&lang=js"
export * from "./DivisionFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports